export const TIMESTAMP = 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'';
export const PT_BR = 'dd/MM/yyyy';
export const ISO_DATE = 'yyyy-MM-dd';
